import { apiSlice } from './apiSlice';
import { TourClassVehicleMatrix } from '../../@types/tourClassVehicleMatrix';

export const tourClassVehicleMatrixSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTourClassVehicleMatricesByTourBundle: builder.query<TourClassVehicleMatrix[], string>({
      query: (tourBundleId) => `/tour-class-vehicle-matrix/by-tour-bundle/${tourBundleId}`,
      providesTags: ['TourClassVehicleMatrix'],
    }),
    createTourClassVehicleMatrix: builder.mutation<
      TourClassVehicleMatrix,
      Omit<TourClassVehicleMatrix, 'id' | 'vehicleTypeName' | 'tourBundleName'>
    >({
      query: (matrix) => ({
        url: '/tour-class-vehicle-matrix',
        method: 'POST',
        body: matrix,
      }),
      invalidatesTags: ['TourClassVehicleMatrix'],
    }),
    updateTourClassVehicleMatrix: builder.mutation<TourClassVehicleMatrix, TourClassVehicleMatrix>({
      query: (matrix) => ({
        url: `/tour-class-vehicle-matrix/${matrix.id}`,
        method: 'PUT',
        body: matrix,
      }),
      invalidatesTags: ['TourClassVehicleMatrix'],
    }),
    deleteTourClassVehicleMatrix: builder.mutation<void, number>({
      query: (id) => ({
        url: `/tour-class-vehicle-matrix/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['TourClassVehicleMatrix'],
    }),
  }),
});

export const {
  useGetTourClassVehicleMatricesByTourBundleQuery,
  useCreateTourClassVehicleMatrixMutation,
  useUpdateTourClassVehicleMatrixMutation,
  useDeleteTourClassVehicleMatrixMutation,
} = tourClassVehicleMatrixSlice;
